import type { CentreData } from './types';
import { naplanTestPackLabels, naplanTestPackGradesByCourse } from '@/config/naplanTestPacks';

export const truganinaData: CentreData = {
  slug: 'truganina',
  name: 'Schoolola Truganina',
  suburb: 'Truganina',
  region: 'Western Melbourne',
  state: 'VIC',
  stateName: 'Victoria',
  status: 'operational',
  yearLevels: 'Prep - Year 8',
  canonicalPath: '/centres/truganina/',
  heroImage: 'https://schoolola.com.au/centres/truganina-og.jpg',
  address: {
    street: 'Koomail Tardy Community Centre, 117 Alcock Rd',
    city: 'Truganina',
    postcode: '3029',
    lat: -37.8175,
    lng: 144.7469,
  },
  contact: {
    phone: '03 7050 9911',
    phoneHref: '+61370509911',
    email: 'truganina@schoololatutoring.com.au',
  },
  hours: {
    monday: { opens: '16:00', closes: '20:00' },
    tuesday: { opens: '16:00', closes: '20:00' },
    wednesday: { opens: '16:00', closes: '20:00' },
    thursday: null,
    friday: null,
    saturday: null,
    sunday: null,
  },
  heroSubtitle:
    'NAPLAN, selective entry and scholarship preparation by qualified Victorian Curriculum teachers.',
  trustStrip: [
    { k: 'In-person', v: 'Koomail Tardy Community Centre' },
    { k: 'Prep - Year 8', v: 'All year levels supported' },
    { k: 'Victorian Curriculum', v: 'Qualified teachers' },
  ],
  breadcrumb: { stateHref: '/states/victoria', regionLabel: 'Western Melbourne' },
  quickBook: {
    featuredCourses: [
      'Foundations Course',
      ...naplanTestPackLabels,
      'Scholarship Exam Preparation',
    ],
    eligibleGrades: ['Prep', 'Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5', 'Year 6', 'Year 7', 'Year 8'],
    gradesByCourse: {
      ...naplanTestPackGradesByCourse,
      'Foundations Course': ['Prep', 'Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5', 'Year 6', 'Year 7', 'Year 8'],
      'Scholarship Exam Preparation': ['Year 5', 'Year 6', 'Year 7', 'Year 8'],
    },
    defaultMeetingType: 'in-person',
    allowOnline: false,
    eyebrow: 'Quick Book',
    title: 'Book your free assessment in 60 seconds',
    subtitle: 'A few quick taps and we\u2019ll lock in a real time with our Truganina team.',
  },
  pathwayIntro:
    'Truganina sits in the catchment of Suzanne Cory High in Werribee - Victoria\u2019s closest fully selective school. Best results come from starting preparation in Year 5 and intensifying in Year 6 ahead of the Year 8 SEAL test.',
  googleRating: {
    value: 5.0,
    count: 10,
    profileUrl: 'https://www.google.com/search?q=Schoolola+Truganina',
  },

  reviews: [
    {
      author: 'Shivanjani Chand',
      rating: 5,
      timeAgo: '2 months ago',
      datePublished: '2026-03-29',
      body: "We've had a wonderful experience with Schoolola Truganina. We have seen a noticeable improvement with both confidence and understanding of subject with my son. The teachers are very supportive, patient and takes time to ensure each child is learning at their own pace.",
    },
    {
      author: 'Gopi krishna Boddu',
      rating: 5,
      timeAgo: '2 months ago',
      datePublished: '2026-03-25',
      body: 'One of the best tutoring centres in Truganina. Highly recommended for parents looking for quality tutoring support for their children.',
    },
    {
      author: 'Midhun kumar Reddy Nellore',
      rating: 5,
      timeAgo: '2 months ago',
      datePublished: '2026-03-20',
      body: 'We were looking for tutoring for our child and we live in Aintree. When we came to Truganina for some other work, we happened to come across Schoolola Tutoring Truganina. So glad we found them.',
    },
    {
      author: 'swathi kammila',
      rating: 5,
      timeAgo: '4 months ago',
      datePublished: '2026-01-28',
      body: 'Great tutoring centre with caring teachers - our child is enjoying every session.',
    },
    {
      author: 'R V',
      rating: 5,
      timeAgo: '5 months ago',
      datePublished: '2025-12-29',
      body: 'We are very happy with Schoolola Tutoring Truganina. The centre is well organised and has ample parking, which makes drop-off and pick-up very easy for parents. The books provided are excellent - colourful, engaging, and especially helpful.',
    },
    {
      author: 'Joe Tuiogo',
      rating: 5,
      timeAgo: '5 months ago',
      datePublished: '2025-12-22',
      body: "I'm very happy with the tutoring my daughter has been receiving in both Math and English. The school work provided is high quality and has really helped her progress toward the next level.",
    },
    {
      author: 'Saidireddy Basireddy',
      rating: 5,
      timeAgo: '5 months ago',
      datePublished: '2025-12-15',
      body: 'Schoolola Tutoring Truganina has been a wonderful experience for our family. The tutors are highly qualified and very supportive, and my child has shown great improvement since joining. The centre is well-organised, and one thing we really appreciate is the personalised attention.',
    },
    {
      author: 'Rutha Tetya',
      rating: 5,
      timeAgo: '5 months ago',
      datePublished: '2025-12-10',
      body: 'Great teachers and very good experience. Girls are improving and showing positive results and homework club has been very helpful with keeping up. Thank you :)',
    },
    {
      author: 'Biar Malith',
      rating: 5,
      timeAgo: '5 months ago',
      datePublished: '2025-12-05',
      body: 'Thank you so much for the tutoring, I can see a progresses now for my daughter.',
    },
    {
      author: 'Vikas Kumar',
      rating: 5,
      timeAgo: '5 months ago',
      datePublished: '2025-12-01',
      body: 'Excellent tutoring centre with dedicated and friendly staff. Highly recommend Schoolola Truganina.',
    },
  ],
  suburbsServed: ['Truganina'],
  localSchools: [
    { name: 'Truganina P-9 College', yearLevels: 'P-9', type: 'Public', distanceKm: 1.5 },
    { name: 'Westbourne Grammar', yearLevels: 'P-12', type: 'Independent', distanceKm: 3.2 },
    { name: 'Al-Taqwa College', yearLevels: 'P-12', type: 'Independent', distanceKm: 2.8 },
    { name: 'Truganina South Primary', yearLevels: 'P-6', type: 'Public', distanceKm: 2.0 },
  ],
  selectiveSchools: [
    { name: 'Suzanne Cory High', location: 'Werribee', distanceKm: 8, status: { label: 'Closest selective', tone: 'info' } },
    { name: 'Mac.Robertson Girls', location: 'Melbourne', distanceKm: 21, status: { label: 'Very competitive', tone: 'warning' } },
    { name: 'Melbourne High', location: 'South Yarra', distanceKm: 25, notes: 'Boys', status: { label: 'Very competitive', tone: 'warning' } },
    { name: 'Nossal High', location: 'Berwick', distanceKm: 57, status: { label: 'Moderate demand', tone: 'info' } },
  ],

  programs: [
    {
      id: 'foundations',
      title: 'Foundations Course',
      yearPill: { label: 'Prep - Year 8', tone: 'success' },
      tagline: 'Core English and maths · all year levels',
      bullets: ['Phonics, fluency, comprehension', 'Number sense to algebra readiness', 'Writing structure across genres'],
      educationalLevel: 'Prep to Year 8',
      description: 'Core English and mathematics tutoring for Prep through Year 8 students at Schoolola Truganina, aligned to the Victorian Curriculum.',
    },
    {
      id: 'naplan',
      title: 'NAPLAN Preparation',
      yearPill: { label: 'Yr 3, 5', tone: 'info' },
      tagline: '10-week term aligned to ACARA',
      bullets: ['Reading and writing', 'Numeracy strategies', 'Language conventions'],
      educationalLevel: 'Year 3 and Year 5',
      description: '10-week term NAPLAN preparation course covering reading, writing, language conventions and numeracy, aligned to ACARA test specifications.',
    },
    {
      id: 'sec',
      title: 'SEC Scholarship Exam Course',
      yearPill: { label: 'Yr 4-6', tone: 'info' },
      tagline: 'ACER and Edutest scholarship preparation',
      bullets: ['SEAL/SEALP training', 'Strategic exam techniques', 'Practice test cycles'],
      featured: 'popular',
      educationalLevel: 'Year 4 to Year 6',
      description: 'Schoolola SEC programmes - SEC TMRW (booklet-based) and the SEC Scholarship Exam Course - preparing students primarily for ACER and Edutest scholarship exams, with SEAL/SEALP training and structured practice test cycles.',
      prerequisites: 'Basic literacy and numeracy at year-level expectations.',
    },
    {
      id: 'assessment',
      title: 'General Assessment',
      yearPill: { label: 'All ages', tone: 'info' },
      tagline: 'Diagnostic assessment for new students',
      bullets: ['Reading, writing, maths diagnostic', '1:1 parent consultation', 'Personalised learning plan'],
      educationalLevel: 'All year levels',
      description: 'Free diagnostic assessment covering reading, writing and maths, followed by a 1:1 parent consultation and a written personalised learning plan.',
    },
  ],
  differentiators: [
    {
      title: 'Victorian Curriculum specialists',
      body: "Our team has analysed the curriculum in depth. Lessons map to what your child's school actually teaches, not generic worksheets.",
      icon: 'BookOpen',
    },
    {
      title: 'Measurable progress reports',
      body: 'Quarterly assessments tracked against ACARA bands. Parents see exactly where their child sits.',
      icon: 'LineChart',
    },
    {
      title: 'Small group ratios',
      body: 'Small group sizes for genuine individual attention while keeping the energy of peer learning.',
      icon: 'Users',
    },
    {
      title: 'Selective and scholarship track record',
      body: 'Network students placed at Suzanne Cory, Mac.Robertson Girls, Melbourne High and Nossal High.',
      icon: 'Trophy',
    },
  ],
  faqs: [
    {
      question: 'What year levels do you tutor in Truganina?',
      answer: 'Prep through Year 8. Foundations covers all year levels in English and maths; NAPLAN, selective entry and scholarship programs target specific testing years.',
    },
    {
      question: 'Where is the Truganina centre located?',
      answer: 'Schoolola Truganina operates from the Koomail Tardy Community Centre at 117 Alcock Rd, Truganina VIC 3029.',
    },
    {
      question: 'What are your operating hours in Truganina?',
      answer: 'Monday, Tuesday and Wednesday from 4:00 PM to 8:00 PM. Assessment bookings are available in 30-minute slots, with the last slot at 7:30 PM.',
    },
    {
      question: 'Do you offer online tutoring at Truganina?',
      answer: 'The Truganina centre is in-person only. Families wanting online tutoring can book through one of our other Victorian centres.',
    },
    {
      question: 'What does the free assessment include?',
      answer: 'A full diagnostic assessment, a 1:1 parent consultation, and a written learning plan with the recommended programme.',
    },
    {
      question: 'Which selective schools do Truganina students target?',
      answer: 'Suzanne Cory High in Werribee is the closest (around 8km). Our Selective Entry program also covers Mac.Robertson Girls, Melbourne High and Nossal High via the Year 8 SEAL test pathway.',
    },
  ],
};
